// Generated file, changes will eventually be overwritten!
import { Talent } from './types';

const talents = {
  ANGER_MANAGEMENT_TALENT: {
    id: 152278,
    name: 'Anger Management',
    icon: 'warrior_talent_icon_angermanagement',
    maxRanks: 1,
    entryIds: [134032],
    definitionIds: [{ id: 138815, specId: 73 }],
  },
  ARMORED_TO_THE_TEETH_TALENT: {
    id: 384124,
    name: 'Armored to the Teeth',
    icon: 'inv_shoulder_22',
    maxRanks: 2,
    entryIds: [112233],
    definitionIds: [{ id: 117238, specId: 73 }],
  },
  ARMOR_SPECIALIZATION_TALENT: {
    id: 1234769,
    name: 'Armor Specialization',
    icon: 'inv_chest_plate05',
    maxRanks: 1,
    entryIds: [112160],
    definitionIds: [{ id: 117165, specId: 73 }],
  },
  ARTERIAL_BLEED_TALENT: {
    id: 440995,
    name: 'Arterial Bleed',
    icon: 'ability_butcher_gushingwounds',
    maxRanks: 1,
    entryIds: [119856],
    definitionIds: [{ id: 124756, specId: 73 }],
  },
  AVATAR_OF_THE_STORM_TALENT: {
    id: 437134,
    name: 'Avatar of the Storm',
    icon: 'achievement_dungeon_blackrockcaverns_ascendantlordobsidius',
    maxRanks: 1,
    entryIds: [117402],
    definitionIds: [{ id: 122414, specId: 73 }],
  },
  AVATAR_TALENT: {
    id: 107574,
    name: 'Avatar',
    icon: 'warrior_talent_icon_avatar',
    maxRanks: 1,
    entryIds: [136703, 112285, 112305],
    definitionIds: [
      { id: 141475, specId: 71 },
      { id: 117290, specId: 72 },
      { id: 117310, specId: 73 },
    ],
  },
  BARBARIC_TRAINING_TALENT: {
    id: 383082,
    name: 'Barbaric Training',
    icon: 'ability_garrosh_whirling_corruption',
    maxRanks: 1,
    entryIds: [112209],
    definitionIds: [{ id: 117214, specId: 73 }],
  },
  BATTLEFIELD_COMMANDER_TALENT: {
    id: 424742,
    name: 'Battlefield Commander',
    icon: 'ability_warrior_commandingshout',
    maxRanks: 1,
    entryIds: [134033],
    definitionIds: [{ id: 138816, specId: 73 }],
  },
  BATTLELORD_TALENT: {
    id: 386630,
    name: 'Battlelord',
    icon: 'ability_pvp_hardiness',
    maxRanks: 1,
    entryIds: [114740],
    definitionIds: [{ id: 119747, specId: 71 }],
  },
  BATTLE_SCARRED_VETERAN_TALENT: {
    id: 386394,
    name: 'Battle-Scarred Veteran',
    icon: 'ability_warrior_endlessrage',
    maxRanks: 1,
    entryIds: [112307],
    definitionIds: [{ id: 117312, specId: 73 }],
  },
  BATTLE_STANCE_TALENT: {
    id: 386164,
    name: 'Battle Stance',
    icon: 'ability_warrior_offensivestance',
    maxRanks: 1,
    entryIds: [112184, 112112],
    definitionIds: [
      { id: 117189, specId: 71 },
      { id: 117117, specId: 73 },
    ],
  },
  BERSERKER_SHOUT_TALENT: {
    id: 384100,
    name: 'Berserker Shout',
    icon: 'spell_nature_ancestralguardian',
    maxRanks: 1,
    entryIds: [112211],
    definitionIds: [{ id: 117216, specId: 73 }],
  },
  BERSERKER_STANCE_TALENT: {
    id: 386196,
    name: 'Berserker Stance',
    icon: 'ability_racial_avatar',
    maxRanks: 1,
    entryIds: [112182],
    definitionIds: [{ id: 117187, specId: 72 }],
  },
  BEST_SERVED_COLD_TALENT: {
    id: 202560,
    name: 'Best Served Cold',
    icon: 'ability_warrior_revenge',
    maxRanks: 1,
    entryIds: [112163],
    definitionIds: [{ id: 117168, specId: 73 }],
  },
  BLADESTORM_TALENT: {
    id: 227847,
    name: 'Bladestorm',
    icon: 'ability_warrior_bladestorm',
    maxRanks: 1,
    entryIds: [112314, 112284],
    definitionIds: [
      { id: 117319, specId: 71 },
      { id: 117289, specId: 72 },
    ],
  },
  BLOODBORNE_ARMS_TALENT: {
    id: 383287,
    name: 'Bloodborne',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 2,
    entryIds: [112135],
    definitionIds: [{ id: 117140, specId: 71 }],
  },
  BLOODBORNE_FURY_TALENT: {
    id: 385703,
    name: 'Bloodborne',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [112270],
    definitionIds: [{ id: 117275, specId: 72 }],
  },
  BLOODBORNE_PROTECTION_TALENT: {
    id: 385704,
    name: 'Bloodborne',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [112115],
    definitionIds: [{ id: 117120, specId: 73 }],
  },
  BLOODCRAZE_TALENT: {
    id: 393950,
    name: 'Bloodcraze',
    icon: 'ability_creature_cursed_02',
    maxRanks: 1,
    entryIds: [112274],
    definitionIds: [{ id: 117279, specId: 72 }],
  },
  BLOODLETTING_TALENT: {
    id: 383154,
    name: 'Bloodletting',
    icon: 'ability_skeer_bloodletting',
    maxRanks: 1,
    entryIds: [112310],
    definitionIds: [{ id: 117315, specId: 71 }],
  },
  BLOODSURGE_TALENT: {
    id: 384361,
    name: 'Bloodsurge',
    icon: 'ability_warrior_bloodsurge',
    maxRanks: 1,
    entryIds: [112129, 112154],
    definitionIds: [
      { id: 117134, specId: 71 },
      { id: 117159, specId: 73 },
    ],
  },
  BLOODTHIRST_TALENT: {
    id: 23881,
    name: 'Bloodthirst',
    icon: 'spell_nature_bloodlust',
    maxRanks: 1,
    entryIds: [112261],
    definitionIds: [{ id: 117266, specId: 72 }],
  },
  BONESHAKER_TALENT: {
    id: 429639,
    name: 'Boneshaker',
    icon: 'ability_deathknight_brittlebones',
    maxRanks: 1,
    entryIds: [117386],
    definitionIds: [{ id: 122398, specId: 73 }],
  },
  BOOMING_VOICE_TALENT: {
    id: 202743,
    name: 'Booming Voice',
    icon: 'ability_warrior_commandingshout',
    maxRanks: 1,
    entryIds: [112170],
    definitionIds: [{ id: 117175, specId: 73 }],
  },
  BOUNDING_STRIDE_TALENT: {
    id: 202163,
    name: 'Bounding Stride',
    icon: 'ability_heroicleap',
    maxRanks: 1,
    entryIds: [112219],
    definitionIds: [{ id: 117224, specId: 73 }],
  },
  BRACE_FOR_IMPACT_TALENT: {
    id: 386030,
    name: 'Brace For Impact',
    icon: 'ability_warrior_shieldguard',
    maxRanks: 1,
    entryIds: [112158],
    definitionIds: [{ id: 117163, specId: 73 }],
  },
  BROAD_STROKES_TALENT: {
    id: 1261049,
    name: 'Broad Strokes',
    icon: 'inv_ability_rogue_echoingreprimand',
    maxRanks: 1,
    entryIds: [135942],
    definitionIds: [{ id: 140697, specId: 71 }],
  },
  BRUTAL_FINISH_TALENT: {
    id: 446085,
    name: 'Brutal Finish',
    icon: 'ability_revendreth_warrior',
    maxRanks: 1,
    entryIds: [123409],
    definitionIds: [{ id: 128247, specId: 72 }],
  },
  BRUTAL_VITALITY_TALENT: {
    id: 384036,
    name: 'Brutal Vitality',
    icon: 'ability_warrior_renewedvigor',
    maxRanks: 1,
    entryIds: [112325],
    definitionIds: [{ id: 117330, specId: 73 }],
  },
  BRUTE_FORCE_TALENT: {
    id: 1261046,
    name: 'Brute Force',
    icon: 'ability_smash',
    maxRanks: 1,
    entryIds: [135936],
    definitionIds: [{ id: 140691, specId: 71 }],
  },
  BURST_OF_POWER_TALENT: {
    id: 437118,
    name: 'Burst of Power',
    icon: 'shaman_pvp_thundercharge',
    maxRanks: 1,
    entryIds: [117404],
    definitionIds: [{ id: 122416, specId: 73 }],
  },
  CAPACITANCE_TALENT: {
    id: 1270724,
    name: 'Capacitance',
    icon: 'spell_nature_purge',
    maxRanks: 1,
    entryIds: [136068],
    definitionIds: [{ id: 140823, specId: 73 }],
  },
  CELERITOUS_CONCLUSION_TALENT: {
    id: 1270710,
    name: 'Celeritous Conclusion',
    icon: 'inv_1115_warrior_fasterreflexes',
    maxRanks: 1,
    entryIds: [136071],
    definitionIds: [{ id: 140826, specId: 73 }],
  },
  CHAMPIONS_SPEAR_TALENT: {
    id: 376079,
    name: "Champion's Spear",
    icon: 'inv_ability_warrior_championsspear',
    maxRanks: 1,
    entryIds: [112247],
    definitionIds: [{ id: 117252, specId: 73 }],
  },
  CLEAVE_TALENT: {
    id: 845,
    name: 'Cleave',
    icon: 'ability_warrior_cleave',
    maxRanks: 1,
    entryIds: [112147],
    definitionIds: [{ id: 117152, specId: 71 }],
    rageCost: 20,
  },
  COLD_STEEL_HOT_BLOOD_TALENT: {
    id: 383959,
    name: 'Cold Steel, Hot Blood',
    icon: 'ability_rogue_hungerforblood',
    maxRanks: 1,
    entryIds: [112271],
    definitionIds: [{ id: 117276, specId: 72 }],
  },
  COLLATERAL_DAMAGE_TALENT: {
    id: 334779,
    name: 'Collateral Damage',
    icon: 'ability_warrior_incite',
    maxRanks: 1,
    entryIds: [135937],
    definitionIds: [{ id: 140692, specId: 71 }],
  },
  COLOSSAL_MIGHT_TALENT: {
    id: 429634,
    name: 'Colossal Might',
    icon: 'ability_warrior_strengthofarms',
    maxRanks: 1,
    entryIds: [117416],
    definitionIds: [{ id: 122428, specId: 73 }],
  },
  COLOSSUS_SMASH_TALENT: {
    id: 167105,
    name: 'Colossus Smash',
    icon: 'inv_warbreaker',
    maxRanks: 1,
    entryIds: [112144],
    definitionIds: [{ id: 117149, specId: 71 }],
  },
  CONDUCTIVITY_TALENT: {
    id: 1270723,
    name: 'Conductivity',
    icon: 'spell_shaman_thunderstorm',
    maxRanks: 1,
    entryIds: [136069],
    definitionIds: [{ id: 140824, specId: 73 }],
  },
  CRACKLING_THUNDER_TALENT: {
    id: 203201,
    name: 'Crackling Thunder',
    icon: 'ability_thunderking_overcharge',
    maxRanks: 1,
    entryIds: [118853],
    definitionIds: [{ id: 123753, specId: 73 }],
  },
  CRASHING_THUNDER_TALENT: {
    id: 436707,
    name: 'Crashing Thunder',
    icon: 'spell_nature_thunderclap',
    maxRanks: 1,
    entryIds: [117413],
    definitionIds: [{ id: 122425, specId: 73 }],
  },
  CRITICAL_THINKING_ARMS_TALENT: {
    id: 389306,
    name: 'Critical Thinking',
    icon: 'ability_criticalstrike',
    maxRanks: 2,
    entryIds: [112317],
    definitionIds: [{ id: 117322, specId: 71 }],
  },
  CRITICAL_THINKING_FURY_TALENT: {
    id: 383297,
    name: 'Critical Thinking',
    icon: 'ability_criticalstrike',
    maxRanks: 2,
    entryIds: [112296],
    definitionIds: [{ id: 117301, specId: 72 }],
  },
  CRUELTY_TALENT: {
    id: 392931,
    name: 'Cruelty',
    icon: 'spell_nature_focusedmind',
    maxRanks: 2,
    entryIds: [112299],
    definitionIds: [{ id: 117304, specId: 72 }],
  },
  CRUEL_STRIKES_TALENT: {
    id: 392777,
    name: 'Cruel Strikes',
    icon: 'ability_criticalstrike',
    maxRanks: 2,
    entryIds: [112248],
    definitionIds: [{ id: 117253, specId: 73 }],
  },
  CRUSHING_COMBO_TALENT: {
    id: 1261056,
    name: 'Crushing Combo',
    icon: 'ability_warrior_cleave',
    maxRanks: 1,
    entryIds: [135938],
    definitionIds: [{ id: 140693, specId: 71 }],
  },
  CRUSHING_FORCE_TALENT: {
    id: 382764,
    name: 'Crushing Force',
    icon: 'spell_shadow_unholystrength',
    maxRanks: 1,
    entryIds: [134226],
    definitionIds: [{ id: 139004, specId: 73 }],
  },
  CULLING_CYCLONE_TALENT: {
    id: 444778,
    name: 'Culling Cyclone',
    icon: 'ability_warrior_bladestorm',
    maxRanks: 1,
    entryIds: [117383],
    definitionIds: [{ id: 122395, specId: 72 }],
  },
  CUT_TO_THE_BONE_TALENT: {
    id: 1270709,
    name: 'Cut to the Bone',
    icon: 'ability_warrior_deepcuts',
    maxRanks: 1,
    entryIds: [136072],
    definitionIds: [{ id: 140827, specId: 73 }],
  },
  DEADLY_FOCUS_TALENT: {
    id: 1270718,
    name: 'Deadly Focus',
    icon: 'spell_hunter_focusingshot',
    maxRanks: 1,
    entryIds: [136075],
    definitionIds: [{ id: 140830, specId: 72 }],
  },
  DEATH_DRIVE_TALENT: {
    id: 444770,
    name: 'Death Drive',
    icon: 'ability_warrior_focusedrage',
    maxRanks: 1,
    entryIds: [117410],
    definitionIds: [{ id: 122422, specId: 72 }],
  },
  DECIMATOR_TALENT: {
    id: 1270704,
    name: 'Decimator',
    icon: 'inv_10_blacksmithing_craftedbar_bloodyalloy',
    maxRanks: 1,
    entryIds: [136073],
    definitionIds: [{ id: 140828, specId: 73 }],
  },
  DEEP_WOUNDS_TALENT: {
    id: 1261060,
    name: 'Deep Wounds',
    icon: 'ability_backstab',
    maxRanks: 1,
    entryIds: [135940, 136451, 112165],
    definitionIds: [
      { id: 140695, specId: 71 },
      { id: 141224, specId: 72 },
      { id: 117170, specId: 73 },
    ],
  },
  DEFENDERS_AEGIS_TALENT: {
    id: 397103,
    name: "Defender's Aegis",
    icon: 'ability_warrior_stalwartprotector',
    maxRanks: 1,
    entryIds: [112174],
    definitionIds: [{ id: 117179, specId: 73 }],
  },
  DEFENSIVE_STANCE_TALENT: {
    id: 386208,
    name: 'Defensive Stance',
    icon: 'ability_warrior_defensivestance',
    maxRanks: 1,
    entryIds: [114643, 114644, 112187],
    definitionIds: [
      { id: 119649, specId: 71 },
      { id: 119650, specId: 72 },
      { id: 117192, specId: 73 },
    ],
  },
  DEFT_EXPERIENCE_TALENT: {
    id: 383295,
    name: 'Deft Experience',
    icon: 'inv_misc_book_07',
    maxRanks: 2,
    entryIds: [112292],
    definitionIds: [{ id: 117297, specId: 72 }],
  },
  DEMOLISH_TALENT: {
    id: 436358,
    name: 'Demolish',
    icon: 'inv_ability_colossuswarrior_demolish',
    maxRanks: 1,
    entryIds: [117415],
    definitionIds: [{ id: 122427, specId: 73 }],
  },
  DEMORALIZING_SHOUT_TALENT: {
    id: 1160,
    name: 'Demoralizing Shout',
    icon: 'ability_warrior_warcry',
    maxRanks: 1,
    entryIds: [112159],
    definitionIds: [{ id: 117164, specId: 73 }],
  },
  DEVASTATING_FOCUS_TALENT: {
    id: 1264330,
    name: 'Devastating Focus',
    icon: 'spell_hunter_focusingshot',
    maxRanks: 1,
    entryIds: [112150],
    definitionIds: [{ id: 117155, specId: 73 }],
  },
  DEVASTATOR_TALENT: {
    id: 236279,
    name: 'Devastator',
    icon: 'inv_sword_11',
    maxRanks: 1,
    entryIds: [112151],
    definitionIds: [{ id: 117156, specId: 73 }],
  },
  DIE_BY_THE_SWORD_TALENT: {
    id: 118038,
    name: 'Die by the Sword',
    icon: 'ability_warrior_challange',
    maxRanks: 1,
    entryIds: [112121],
    definitionIds: [{ id: 117126, specId: 71 }],
  },
  DISRUPTING_SHOUT_TALENT: {
    id: 386071,
    name: 'Disrupting Shout',
    icon: 'ability_bullrush',
    maxRanks: 1,
    entryIds: [132886],
    definitionIds: [{ id: 137672, specId: 73 }],
  },
  DOMINANCE_OF_THE_COLOSSUS_TALENT: {
    id: 429636,
    name: 'Dominance of the Colossus',
    icon: 'ability_warrior_titansgrip',
    maxRanks: 1,
    entryIds: [117390],
    definitionIds: [{ id: 122402, specId: 73 }],
  },
  DOUBLE_TIME_TALENT: {
    id: 103827,
    name: 'Double Time',
    icon: 'inv_misc_horn_04',
    maxRanks: 1,
    entryIds: [112249],
    definitionIds: [{ id: 117254, specId: 73 }],
  },
  DREADNAUGHT_TALENT: {
    id: 262150,
    name: 'Dreadnaught',
    icon: 'inv_sword_05',
    maxRanks: 1,
    entryIds: [112137],
    definitionIds: [{ id: 117142, specId: 71 }],
  },
  DUAL_WIELD_SPECIALIZATION_TALENT: {
    id: 382900,
    name: 'Dual Wield Specialization',
    icon: 'ability_dualwield',
    maxRanks: 2,
    entryIds: [112240],
    definitionIds: [{ id: 117245, specId: 72 }],
  },
  EARTHQUAKER_TALENT: {
    id: 440992,
    name: 'Earthquaker',
    icon: 'spell_shaman_earthquake',
    maxRanks: 1,
    entryIds: [119858],
    definitionIds: [{ id: 124758, specId: 73 }],
  },
  EFFICIENCY_TALENT: {
    id: 1261047,
    name: 'Efficiency',
    icon: 'ability_warrior_revenge',
    maxRanks: 1,
    entryIds: [135935],
    definitionIds: [{ id: 140690, specId: 71 }],
  },
  ENDURING_ALACRITY_TALENT: {
    id: 384063,
    name: 'Enduring Alacrity',
    icon: 'spell_nature_unyeildingstamina',
    maxRanks: 1,
    entryIds: [132882],
    definitionIds: [{ id: 137668, specId: 73 }],
  },
  ENDURING_DEFENSES_TALENT: {
    id: 386027,
    name: 'Enduring Defenses',
    icon: 'ability_defend',
    maxRanks: 2,
    entryIds: [112166],
    definitionIds: [{ id: 117171, specId: 73 }],
  },
  ENRAGED_REGENERATION_TALENT: {
    id: 184364,
    name: 'Enraged Regeneration',
    icon: 'ability_warrior_focusedrage',
    maxRanks: 1,
    entryIds: [112264],
    definitionIds: [{ id: 117269, specId: 72 }],
  },
  EXECUTIONERS_PRECISION_TALENT: {
    id: 386634,
    name: "Executioner's Precision",
    icon: 'ability_revendreth_warrior',
    maxRanks: 1,
    entryIds: [112318],
    definitionIds: [{ id: 117323, specId: 71 }],
  },
  EXECUTIONERS_WRATH_TALENT: {
    id: 1265570,
    name: "Executioner's Wrath",
    icon: 'inv_12_nonmasculinecharacter_human',
    maxRanks: 1,
    entryIds: [136453],
    definitionIds: [{ id: 141226, specId: 72 }],
  },
  FAST_FOOTWORK_TALENT: {
    id: 382260,
    name: 'Fast Footwork',
    icon: 'ability_hunter_posthaste',
    maxRanks: 1,
    entryIds: [112206],
    definitionIds: [{ id: 117211, specId: 73 }],
  },
  FATALITY_TALENT: {
    id: 383703,
    name: 'Fatality',
    icon: 'achievement_bg_killingblow_berserker',
    maxRanks: 1,
    entryIds: [112311],
    definitionIds: [{ id: 117316, specId: 71 }],
  },
  FEARLESS_TALENT: {
    id: 1271925,
    name: 'Fearless',
    icon: 'ability_warrior_endlessrage',
    maxRanks: 1,
    entryIds: [112210],
    definitionIds: [{ id: 117215, specId: 73 }],
  },
  FERVOR_OF_BATTLE_TALENT: {
    id: 202316,
    name: 'Fervor of Battle',
    icon: 'ability_rogue_waylay',
    maxRanks: 1,
    entryIds: [135932],
    definitionIds: [{ id: 140687, specId: 71 }],
  },
  FIELD_DRESSING_TALENT: {
    id: 1271926,
    name: 'Field Dressing',
    icon: 'inv_misc_bandage_08',
    maxRanks: 1,
    entryIds: [136626],
    definitionIds: [{ id: 141398, specId: 73 }],
  },
  FIERCE_FOLLOWTHROUGH_TALENT: {
    id: 444773,
    name: 'Fierce Followthrough',
    icon: 'spell_deathknight_butcher2',
    maxRanks: 1,
    entryIds: [117384],
    definitionIds: [{ id: 122396, specId: 72 }],
  },
  FIGHT_THROUGH_THE_FLAMES_TALENT: {
    id: 452494,
    name: 'Fight Through the Flames',
    icon: 'ability_racial_foregedinflames',
    maxRanks: 1,
    entryIds: [112153],
    definitionIds: [{ id: 117158, specId: 73 }],
  },
  FLASHING_SKIES_TALENT: {
    id: 437079,
    name: 'Flashing Skies',
    icon: 'spell_lightning_lightningbolt01',
    maxRanks: 1,
    entryIds: [117394],
    definitionIds: [{ id: 122406, specId: 73 }],
  },
  FOCUSED_VIGOR_TALENT: {
    id: 384067,
    name: 'Focused Vigor',
    icon: 'spell_nature_strength',
    maxRanks: 1,
    entryIds: [132883],
    definitionIds: [{ id: 137669, specId: 73 }],
  },
  FOCUS_IN_CHAOS_TALENT: {
    id: 383486,
    name: 'Focus in Chaos',
    icon: 'ability_hunter_mastermarksman',
    maxRanks: 1,
    entryIds: [112272],
    definitionIds: [{ id: 117277, specId: 72 }],
  },
  FRENZIED_ENRAGE_TALENT: {
    id: 383848,
    name: 'Frenzied Enrage',
    icon: 'spell_shadow_unholyfrenzy',
    maxRanks: 1,
    entryIds: [112267],
    definitionIds: [{ id: 117272, specId: 72 }],
  },
  FRENZY_TALENT: {
    id: 335077,
    name: 'Frenzy',
    icon: 'ability_rogue_bloodyeye',
    maxRanks: 1,
    entryIds: [112275],
    definitionIds: [{ id: 117280, specId: 72 }],
  },
  FRESH_MEAT_TALENT: {
    id: 215568,
    name: 'Fresh Meat',
    icon: 'ability_deathwing_bloodcorruption_death',
    maxRanks: 1,
    entryIds: [112268],
    definitionIds: [{ id: 117273, specId: 72 }],
  },
  FROTHING_BERSERKER_TALENT: {
    id: 392792,
    name: 'Frothing Berserker',
    icon: 'warrior_talent_icon_furyintheblood',
    maxRanks: 1,
    entryIds: [112216],
    definitionIds: [{ id: 117221, specId: 73 }],
  },
  FUELED_BY_VIOLENCE_TALENT: {
    id: 383103,
    name: 'Fueled by Violence',
    icon: 'ability_demonhunter_bloodlet',
    maxRanks: 1,
    entryIds: [112128, 112176],
    definitionIds: [
      { id: 117133, specId: 71 },
      { id: 117181, specId: 73 },
    ],
  },
  GATHERING_CLOUDS_TALENT: {
    id: 436201,
    name: 'Gathering Clouds',
    icon: 'spell_nature_stormreach',
    maxRanks: 1,
    entryIds: [117389],
    definitionIds: [{ id: 122401, specId: 73 }],
  },
  GROUND_CURRENT_TALENT: {
    id: 436148,
    name: 'Ground Current',
    icon: 'warrior_talent_icon_thunderstruck',
    maxRanks: 1,
    entryIds: [117397],
    definitionIds: [{ id: 122409, specId: 73 }],
  },
  HACK_AND_SLASH_TALENT: {
    id: 383877,
    name: 'Hack and Slash',
    icon: 'ability_rogue_rollthebones02',
    maxRanks: 1,
    entryIds: [112276],
    definitionIds: [{ id: 117281, specId: 72 }],
  },
  HEAVY_HANDED_TALENT: {
    id: 1235088,
    name: 'Heavy Handed',
    icon: 'inv_1115_warrior_crushingblow',
    maxRanks: 1,
    entryIds: [112169],
    definitionIds: [{ id: 117174, specId: 73 }],
  },
  HEAVY_REPERCUSSIONS_TALENT: {
    id: 203177,
    name: 'Heavy Repercussions',
    icon: 'inv_shield_32',
    maxRanks: 1,
    entryIds: [112167],
    definitionIds: [{ id: 117172, specId: 73 }],
  },
  HEROIC_LEAP_TALENT: {
    id: 6544,
    name: 'Heroic Leap',
    icon: 'ability_heroicleap',
    maxRanks: 1,
    entryIds: [112208],
    definitionIds: [{ id: 117213, specId: 73 }],
  },
  HONED_REFLEXES_TALENT: {
    id: 391271,
    name: 'Honed Reflexes',
    icon: 'spell_holy_borrowedtime',
    maxRanks: 1,
    entryIds: [118850],
    definitionIds: [{ id: 123750, specId: 73 }],
  },
  HUNKER_DOWN_TALENT: {
    id: 1235022,
    name: 'Hunker Down',
    icon: 'ability_warrior_shieldreflection',
    maxRanks: 1,
    entryIds: [112110],
    definitionIds: [{ id: 117115, specId: 73 }],
  },
  IGNORE_PAIN_ARMS_TALENT: {
    id: 1277297,
    name: 'Ignore Pain',
    icon: 'ability_warrior_renewedvigor',
    maxRanks: 1,
    entryIds: [136701],
    definitionIds: [{ id: 141473, specId: 71 }],
  },
  IGNORE_PAIN_PROTECTION_TALENT: {
    id: 190456,
    name: 'Ignore Pain',
    icon: 'ability_warrior_renewedvigor',
    maxRanks: 1,
    entryIds: [112149],
    definitionIds: [{ id: 117154, specId: 73 }],
    rageCost: 35,
  },
  IMMINENT_DEMISE_TALENT: {
    id: 444769,
    name: 'Imminent Demise',
    icon: 'ability_warrior_improveddisciplines',
    maxRanks: 1,
    entryIds: [117385],
    definitionIds: [{ id: 122397, specId: 72 }],
  },
  IMPALE_TALENT: {
    id: 383430,
    name: 'Impale',
    icon: 'ability_searingarrow',
    maxRanks: 1,
    entryIds: [112146],
    definitionIds: [{ id: 117151, specId: 71 }],
  },
  IMPENDING_VICTORY_TALENT: {
    id: 202168,
    name: 'Impending Victory',
    icon: 'spell_impending_victory',
    maxRanks: 1,
    entryIds: [112183],
    definitionIds: [{ id: 117188, specId: 73 }],
    rageCost: 10,
  },
  IMPENETRABLE_WALL_TALENT: {
    id: 384072,
    name: 'Impenetrable Wall',
    icon: 'ability_warrior_shieldguard',
    maxRanks: 1,
    entryIds: [132881],
    definitionIds: [{ id: 137667, specId: 73 }],
  },
  IMPROVED_EXECUTE_ARMS_TALENT: {
    id: 316405,
    name: 'Improved Execute',
    icon: 'inv_sword_48',
    maxRanks: 1,
    entryIds: [112125],
    definitionIds: [{ id: 117130, specId: 71 }],
  },
  IMPROVED_EXECUTE_FURY_TALENT: {
    id: 316402,
    name: 'Improved Execute',
    icon: 'inv_sword_48',
    maxRanks: 1,
    entryIds: [112300],
    definitionIds: [{ id: 117305, specId: 72 }],
  },
  IMPROVED_OVERPOWER_TALENT: {
    id: 385571,
    name: 'Improved Overpower',
    icon: 'ability_meleedamage',
    maxRanks: 1,
    entryIds: [112131],
    definitionIds: [{ id: 117136, specId: 71 }],
  },
  IMPROVED_RAGING_BLOW_TALENT: {
    id: 383854,
    name: 'Improved Raging Blow',
    icon: 'warrior_wild_strike',
    maxRanks: 1,
    entryIds: [112259],
    definitionIds: [{ id: 117264, specId: 72 }],
  },
  IMPROVED_SWEEPING_STRIKES_TALENT: {
    id: 383155,
    name: 'Improved Sweeping Strikes',
    icon: 'ability_rogue_slicedice',
    maxRanks: 1,
    entryIds: [114641],
    definitionIds: [{ id: 119647, specId: 71 }],
  },
  IMPROVED_WHIRLWIND_TALENT: {
    id: 12950,
    name: 'Improved Whirlwind',
    icon: 'ability_whirlwind',
    maxRanks: 1,
    entryIds: [112298],
    definitionIds: [{ id: 117303, specId: 72 }],
  },
  INDOMITABLE_TALENT: {
    id: 202095,
    name: 'Indomitable',
    icon: 'ability_warrior_intensifyrage',
    maxRanks: 1,
    entryIds: [112306],
    definitionIds: [{ id: 117311, specId: 73 }],
  },
  INSTIGATE_TALENT: {
    id: 394311,
    name: 'Instigate',
    icon: 'ability_rogue_dismantle',
    maxRanks: 1,
    entryIds: [112155],
    definitionIds: [{ id: 117160, specId: 73 }],
  },
  INTERPOSE_TALENT: {
    id: 1244088,
    name: 'Interpose',
    icon: 'ability_paladin_speedoflight',
    maxRanks: 1,
    entryIds: [134216, 134213],
    definitionIds: [
      { id: 138994, specId: 71 },
      { id: 138991, specId: 72 },
    ],
  },
  INTERVENE_TALENT: {
    id: 3411,
    name: 'Intervene',
    icon: 'ability_warrior_victoryrush',
    maxRanks: 1,
    entryIds: [134217, 134214, 112186],
    definitionIds: [
      { id: 141828, specId: 71 },
      { id: 138992, specId: 72 },
      { id: 117191, specId: 73 },
    ],
  },
  INTIMIDATING_SHOUT_TALENT: {
    id: 5246,
    name: 'Intimidating Shout',
    icon: 'ability_golemthunderclap',
    maxRanks: 1,
    entryIds: [134254],
    definitionIds: [{ id: 139027, specId: 73 }],
  },
  INTO_THE_FRAY_TALENT: {
    id: 202603,
    name: 'Into the Fray',
    icon: 'ability_warrior_bloodfrenzy',
    maxRanks: 1,
    entryIds: [132885],
    definitionIds: [{ id: 137671, specId: 73 }],
  },
  INVIGORATING_FURY_TALENT: {
    id: 383468,
    name: 'Invigorating Fury',
    icon: 'spell_misc_emotionangry',
    maxRanks: 1,
    entryIds: [136890],
    definitionIds: [{ id: 141653, specId: 72 }],
  },
  JAVELINEER_TALENT: {
    id: 1271948,
    name: 'Javelineer',
    icon: 'inv_spear_01',
    maxRanks: 1,
    entryIds: [136625],
    definitionIds: [{ id: 141397, specId: 73 }],
  },
  JUST_WARMING_UP_TALENT: {
    id: 1261048,
    name: 'Just Warming Up',
    icon: 'ability_warrior_endlessrage',
    maxRanks: 1,
    entryIds: [135943],
    definitionIds: [{ id: 140698, specId: 71 }],
  },
  KEEP_YOUR_FEET_ON_THE_GROUND_TALENT: {
    id: 438590,
    name: 'Keep Your Feet on the Ground',
    icon: 'ability_thunderking_overcharge',
    maxRanks: 1,
    entryIds: [117395],
    definitionIds: [{ id: 122407, specId: 73 }],
  },
  KILL_OR_BE_KILLED_TALENT: {
    id: 1265361,
    name: 'Kill or Be Killed',
    icon: 'inv12_ability_warrior_fury',
    maxRanks: 1,
    entryIds: [136450],
    definitionIds: [{ id: 141223, specId: 72 }],
  },
  LAST_STAND_TALENT: {
    id: 1243659,
    name: 'Last Stand',
    icon: 'spell_holy_ashestoashes',
    maxRanks: 1,
    entryIds: [132879],
    definitionIds: [{ id: 137665, specId: 73 }],
  },
  LEECHING_STRIKES_TALENT: {
    id: 382258,
    name: 'Leeching Strikes',
    icon: 'inv_artifact_bloodoftheassassinated',
    maxRanks: 1,
    entryIds: [112238],
    definitionIds: [{ id: 117243, specId: 73 }],
  },
  LIGHTNING_STRIKES_TALENT: {
    id: 434969,
    name: 'Lightning Strikes',
    icon: 'ability_vehicle_electrocharge',
    maxRanks: 1,
    entryIds: [117400],
    definitionIds: [{ id: 122412, specId: 73 }],
  },
  MARTIAL_EXPERT_TALENT: {
    id: 429638,
    name: 'Martial Expert',
    icon: 'ability_warrior_stalwartprotector',
    maxRanks: 1,
    entryIds: [117409],
    definitionIds: [{ id: 122421, specId: 73 }],
  },
  MARTIAL_PROWESS_TALENT: {
    id: 1273062,
    name: 'Martial Prowess',
    icon: 'warrior_talent_icon_igniteweapon',
    maxRanks: 1,
    entryIds: [135934],
    definitionIds: [{ id: 140689, specId: 71 }],
  },
  MASSACRE_FURY_TALENT: {
    id: 206315,
    name: 'Massacre',
    icon: 'inv_axe_2h_orcwarrior_c_01',
    maxRanks: 1,
    entryIds: [112279],
    definitionIds: [{ id: 117284, specId: 72 }],
  },
  MASSACRE_SPEC_TALENT: {
    id: 281001,
    name: 'Massacre',
    icon: 'inv_axe_2h_orcwarrior_c_01',
    maxRanks: 1,
    entryIds: [112145, 132878],
    definitionIds: [
      { id: 117150, specId: 71 },
      { id: 137664, specId: 73 },
    ],
  },
  MASS_EXECUTION_TALENT: {
    id: 1273075,
    name: 'Mass Execution',
    icon: 'warrior_talent_icon_mastercleaver',
    maxRanks: 1,
    entryIds: [136700],
    definitionIds: [{ id: 141472, specId: 71 }],
  },
  MASTER_OF_WARFARE_1_ARMS_TALENT: {
    id: 1269314,
    name: 'Master of Warfare',
    icon: 'inv12_apextalent_warrior_masterofwarfare',
    maxRanks: 1,
    entryIds: [136989],
    definitionIds: [{ id: 141752, specId: 71 }],
  },
  MASTER_OF_WARFARE_2_ARMS_TALENT: {
    id: 1269306,
    name: 'Master of Warfare',
    icon: 'inv12_apextalent_warrior_masterofwarfare',
    maxRanks: 2,
    entryIds: [136988],
    definitionIds: [{ id: 141751, specId: 71 }],
  },
  MASTER_OF_WARFARE_3_ARMS_TALENT: {
    id: 1269307,
    name: 'Master of Warfare',
    icon: 'inv12_apextalent_warrior_masterofwarfare',
    maxRanks: 1,
    entryIds: [136987],
    definitionIds: [{ id: 141750, specId: 71 }],
  },
  MASTER_TACTICIAN_TALENT: {
    id: 1261057,
    name: 'Master Tactician',
    icon: 'ability_warrior_revenge',
    maxRanks: 1,
    entryIds: [135933],
    definitionIds: [{ id: 140688, specId: 71 }],
  },
  MEAT_CLEAVER_TALENT: {
    id: 280392,
    name: 'Meat Cleaver',
    icon: 'warrior_talent_icon_mastercleaver',
    maxRanks: 1,
    entryIds: [136452],
    definitionIds: [{ id: 141225, specId: 72 }],
  },
  MORTAL_STRIKE_TALENT: {
    id: 12294,
    name: 'Mortal Strike',
    icon: 'ability_warrior_savageblow',
    maxRanks: 1,
    entryIds: [112122],
    definitionIds: [{ id: 117127, specId: 71 }],
    rageCost: 30,
  },
  MORTAL_WOUNDS_TALENT: {
    id: 1261062,
    name: 'Mortal Wounds',
    icon: 'ability_warrior_bloodbath',
    maxRanks: 1,
    entryIds: [135941],
    definitionIds: [{ id: 140696, specId: 71 }],
  },
  MOUNTAIN_OF_MUSCLE_AND_SCARS_TALENT: {
    id: 429642,
    name: 'Mountain of Muscle and Scars',
    icon: 'ability_warrior_intensifyrage',
    maxRanks: 1,
    entryIds: [117403],
    definitionIds: [{ id: 122415, specId: 73 }],
  },
  NO_STRANGER_TO_PAIN_TALENT: {
    id: 429644,
    name: 'No Stranger to Pain',
    icon: 'ability_warrior_renewedvigor',
    maxRanks: 1,
    entryIds: [117412],
    definitionIds: [{ id: 122424, specId: 73 }],
  },
  ODYNS_FURY_TALENT: {
    id: 385059,
    name: "Odyn's Fury",
    icon: 'inv_sword_1h_artifactvigfus_d_01',
    maxRanks: 1,
    entryIds: [136735],
    definitionIds: [{ id: 141507, specId: 72 }],
  },
  ONE_AGAINST_MANY_TALENT: {
    id: 429637,
    name: 'One Against Many',
    icon: 'ability_warrior_incite',
    maxRanks: 1,
    entryIds: [117396],
    definitionIds: [{ id: 122408, specId: 73 }],
  },
  ONE_HANDED_WEAPON_SPECIALIZATION_TALENT: {
    id: 382895,
    name: 'One-Handed Weapon Specialization',
    icon: 'inv_sword_20',
    maxRanks: 2,
    entryIds: [112181],
    definitionIds: [{ id: 117186, specId: 73 }],
  },
  OPPORTUNIST_TALENT: {
    id: 444774,
    name: 'Opportunist',
    icon: 'ability_warrior_weaponmastery',
    maxRanks: 1,
    entryIds: [123770],
    definitionIds: [{ id: 128608, specId: 72 }],
  },
  OVERPOWERING_FINISH_TALENT: {
    id: 400205,
    name: 'Overpowering Finish',
    icon: 'ability_warrior_punishingblow',
    maxRanks: 1,
    entryIds: [114733],
    definitionIds: [{ id: 119740, specId: 71 }],
  },
  OVERPOWER_TALENT: {
    id: 7384,
    name: 'Overpower',
    icon: 'ability_meleedamage',
    maxRanks: 1,
    entryIds: [112123],
    definitionIds: [{ id: 117128, specId: 71 }],
  },
  OVERWHELMING_BLADES_TALENT: {
    id: 444772,
    name: 'Overwhelming Blades',
    icon: 'inv_10_specialization_blacksmithing_blades_color1',
    maxRanks: 1,
    entryIds: [117407],
    definitionIds: [{ id: 122419, specId: 72 }],
  },
  OVERWHELMING_RAGE_TALENT: {
    id: 382767,
    name: 'Overwhelming Rage',
    icon: 'racial_orc_berserkerstrength',
    maxRanks: 1,
    entryIds: [112245],
    definitionIds: [{ id: 117250, specId: 73 }],
  },
  PAIN_AND_GAIN_TALENT: {
    id: 382549,
    name: 'Pain and Gain',
    icon: 'spell_holy_painsupression',
    maxRanks: 1,
    entryIds: [112217],
    definitionIds: [{ id: 117222, specId: 73 }],
  },
  PHALANX_1_PROTECTION_TALENT: {
    id: 1269311,
    name: 'Phalanx',
    icon: 'inv12_apextalent_warrior_phalanx',
    maxRanks: 1,
    entryIds: [137001],
    definitionIds: [{ id: 141764, specId: 73 }],
  },
  PHALANX_2_PROTECTION_TALENT: {
    id: 1269312,
    name: 'Phalanx',
    icon: 'inv12_apextalent_warrior_phalanx',
    maxRanks: 2,
    entryIds: [137000],
    definitionIds: [{ id: 141763, specId: 73 }],
  },
  PHALANX_3_PROTECTION_TALENT: {
    id: 1269313,
    name: 'Phalanx',
    icon: 'inv12_apextalent_warrior_phalanx',
    maxRanks: 1,
    entryIds: [136999],
    definitionIds: [{ id: 141762, specId: 73 }],
  },
  PIERCING_HOWL_TALENT: {
    id: 12323,
    name: 'Piercing Howl',
    icon: 'spell_shadow_deathscream',
    maxRanks: 1,
    entryIds: [136627],
    definitionIds: [{ id: 141399, specId: 73 }],
  },
  POWERFUL_ENRAGE_TALENT: {
    id: 440277,
    name: 'Powerful Enrage',
    icon: 'ability_warrior_strengthofarms',
    maxRanks: 1,
    entryIds: [119112],
    definitionIds: [{ id: 124012, specId: 72 }],
  },
  POWERFUL_MOMENTUM_TALENT: {
    id: 1261050,
    name: 'Powerful Momentum',
    icon: 'inv_1115_warrior_crushingblow',
    maxRanks: 1,
    entryIds: [114739],
    definitionIds: [{ id: 119746, specId: 71 }],
  },
  PRACTICED_STRIKES_TALENT: {
    id: 429647,
    name: 'Practiced Strikes',
    icon: 'spell_warrior_sharpenblade',
    maxRanks: 1,
    entryIds: [117393],
    definitionIds: [{ id: 122405, specId: 73 }],
  },
  PRECISE_MIGHT_TALENT: {
    id: 431548,
    name: 'Precise Might',
    icon: 'spell_hunter_focusingshot',
    maxRanks: 1,
    entryIds: [117391],
    definitionIds: [{ id: 122403, specId: 73 }],
  },
  PUNISH_TALENT: {
    id: 275334,
    name: 'Punish',
    icon: 'ability_deathknight_sanguinfortitude',
    maxRanks: 1,
    entryIds: [112321],
    definitionIds: [{ id: 117326, specId: 73 }],
  },
  RAGEDRINKER_TALENT: {
    id: 1265356,
    name: 'Ragedrinker',
    icon: 'spell_nzinsanity_bloodthirst',
    maxRanks: 1,
    entryIds: [136447],
    definitionIds: [{ id: 141220, specId: 72 }],
  },
  RAGING_BLOW_TALENT: {
    id: 85288,
    name: 'Raging Blow',
    icon: 'warrior_wild_strike',
    maxRanks: 1,
    entryIds: [112265],
    definitionIds: [{ id: 117270, specId: 72 }],
  },
  RALLYING_CRY_TALENT: {
    id: 97462,
    name: 'Rallying Cry',
    icon: 'ability_warrior_rallyingcry',
    maxRanks: 1,
    entryIds: [112188],
    definitionIds: [{ id: 117193, specId: 73 }],
  },
  RAMPAGE_TALENT: {
    id: 184367,
    name: 'Rampage',
    icon: 'ability_warrior_rampage',
    maxRanks: 1,
    entryIds: [112277],
    definitionIds: [{ id: 117282, specId: 72 }],
    rageCost: 80,
  },
  RAMPAGING_BERSERKER_1_FURY_TALENT: {
    id: 1269308,
    name: 'Rampaging Berserker',
    icon: 'inv12_apextalent_warrior_rampagingberserker2',
    maxRanks: 1,
    entryIds: [137004],
    definitionIds: [{ id: 141767, specId: 72 }],
  },
  RAMPAGING_BERSERKER_2_FURY_TALENT: {
    id: 1269309,
    name: 'Rampaging Berserker',
    icon: 'inv12_apextalent_warrior_rampagingberserker2',
    maxRanks: 2,
    entryIds: [137003],
    definitionIds: [{ id: 141766, specId: 72 }],
  },
  RAMPAGING_BERSERKER_3_FURY_TALENT: {
    id: 1269310,
    name: 'Rampaging Berserker',
    icon: 'inv12_apextalent_warrior_rampagingberserker2',
    maxRanks: 1,
    entryIds: [137002],
    definitionIds: [{ id: 141765, specId: 72 }],
  },
  RAMPAGING_RUIN_TALENT: {
    id: 1265357,
    name: 'Rampaging Ruin',
    icon: 'ability_warrior_trauma',
    maxRanks: 1,
    entryIds: [112260],
    definitionIds: [{ id: 117265, specId: 72 }],
  },
  RAVAGER_TALENT: {
    id: 228920,
    name: 'Ravager',
    icon: 'warrior_talent_icon_ravager',
    maxRanks: 1,
    entryIds: [136702, 132880],
    definitionIds: [
      { id: 141474, specId: 71 },
      { id: 137666, specId: 73 },
    ],
  },
  REAP_THE_STORM_TALENT: {
    id: 444775,
    name: 'Reap the Storm',
    icon: 'ability_arakkoa_spinning_blade',
    maxRanks: 1,
    entryIds: [117406],
    definitionIds: [{ id: 122418, specId: 72 }],
  },
  RECKLESSNESS_TALENT: {
    id: 1719,
    name: 'Recklessness',
    icon: 'warrior_talent_icon_innerrage',
    maxRanks: 1,
    entryIds: [112281],
    definitionIds: [{ id: 117286, specId: 72 }],
  },
  RECKLESS_ABANDON_TALENT: {
    id: 396749,
    name: 'Reckless Abandon',
    icon: 'spell_fire_incinerate',
    maxRanks: 1,
    entryIds: [119139],
    definitionIds: [{ id: 124039, specId: 72 }],
  },
  REINFORCED_PLATES_TALENT: {
    id: 382939,
    name: 'Reinforced Plates',
    icon: 'inv_chest_plate04',
    maxRanks: 2,
    entryIds: [112235],
    definitionIds: [{ id: 117240, specId: 73 }],
  },
  RELENTLESS_PURSUIT_TALENT: {
    id: 444776,
    name: 'Relentless Pursuit',
    icon: 'ability_rogue_sprint',
    maxRanks: 1,
    entryIds: [117392],
    definitionIds: [{ id: 122404, specId: 72 }],
  },
  REND_TALENT: {
    id: 772,
    name: 'Rend',
    icon: 'ability_gouge',
    maxRanks: 1,
    entryIds: [135597],
    definitionIds: [{ id: 140353, specId: 73 }],
    rageCost: 20,
  },
  RESONANT_VOICE_TALENT: {
    id: 1243660,
    name: 'Resonant Voice',
    icon: 'warrior_disruptingshout',
    maxRanks: 1,
    entryIds: [134225],
    definitionIds: [{ id: 139003, specId: 73 }],
  },
  REVENGE_TALENT: {
    id: 6572,
    name: 'Revenge',
    icon: 'ability_warrior_revenge',
    maxRanks: 1,
    entryIds: [112152],
    definitionIds: [{ id: 117157, specId: 73 }],
    rageCost: 20,
  },
  RUMBLING_EARTH_TALENT: {
    id: 275339,
    name: 'Rumbling Earth',
    icon: 'spell_shaman_earthquake',
    maxRanks: 1,
    entryIds: [112241],
    definitionIds: [{ id: 117246, specId: 73 }],
  },
  SCENT_OF_BLOOD_TALENT: {
    id: 1265355,
    name: 'Scent of Blood',
    icon: 'ability_hunter_harass',
    maxRanks: 1,
    entryIds: [136454],
    definitionIds: [{ id: 141227, specId: 72 }],
  },
  SECOND_WIND_TALENT: {
    id: 29838,
    name: 'Second Wind',
    icon: 'ability_hunter_harass',
    maxRanks: 1,
    entryIds: [112190],
    definitionIds: [{ id: 117195, specId: 73 }],
  },
  SHARPENED_BLADES_TALENT: {
    id: 383341,
    name: 'Sharpened Blades',
    icon: 'inv_sword_27',
    maxRanks: 2,
    entryIds: [112320],
    definitionIds: [{ id: 117325, specId: 71 }],
  },
  SHATTERING_THROW_TALENT: {
    id: 64382,
    name: 'Shattering Throw',
    icon: 'ability_warrior_shatteringthrow',
    maxRanks: 1,
    entryIds: [112214],
    definitionIds: [{ id: 117219, specId: 73 }],
  },
  SHIELD_CHARGE_TALENT: {
    id: 385952,
    name: 'Shield Charge',
    icon: 'ability_warrior_shieldcharge',
    maxRanks: 1,
    entryIds: [112173],
    definitionIds: [{ id: 117178, specId: 73 }],
  },
  SHIELD_SPECIALIZATION_TALENT: {
    id: 386011,
    name: 'Shield Specialization',
    icon: 'inv_shield_76',
    maxRanks: 1,
    entryIds: [112171],
    definitionIds: [{ id: 117176, specId: 73 }],
  },
  SHIELD_WALL_TALENT: {
    id: 871,
    name: 'Shield Wall',
    icon: 'ability_warrior_shieldwall',
    maxRanks: 1,
    entryIds: [112156],
    definitionIds: [{ id: 117161, specId: 73 }],
  },
  SHOCKWAVE_TALENT: {
    id: 46968,
    name: 'Shockwave',
    icon: 'ability_warrior_shockwave',
    maxRanks: 1,
    entryIds: [112242],
    definitionIds: [{ id: 117247, specId: 73 }],
  },
  SHOW_NO_MERCY_TALENT: {
    id: 444771,
    name: 'Show No Mercy',
    icon: 'warrior_talent_icon_lambstotheslaughter',
    maxRanks: 1,
    entryIds: [117381],
    definitionIds: [{ id: 122393, specId: 72 }],
  },
  SLAYERS_DOMINANCE_TALENT: {
    id: 444767,
    name: "Slayer's Dominance",
    icon: 'inv_ability_slayerwarrior_slayersdominance',
    maxRanks: 1,
    entryIds: [117411],
    definitionIds: [{ id: 122423, specId: 72 }],
  },
  SLAYERS_MALICE_TALENT: {
    id: 444779,
    name: "Slayer's Malice",
    icon: 'ability_warrior_revenge',
    maxRanks: 1,
    entryIds: [117398],
    definitionIds: [{ id: 122410, specId: 72 }],
  },
  SNAP_INDUCTION_TALENT: {
    id: 456270,
    name: 'Snap Induction',
    icon: 'ability_thunderking_thunderstruck',
    maxRanks: 1,
    entryIds: [118833],
    definitionIds: [{ id: 123733, specId: 73 }],
  },
  SPELLBREAKER_TALENT: {
    id: 1235023,
    name: 'Spellbreaker',
    icon: 'inv_helm_armor_bloodelf_d_01',
    maxRanks: 1,
    entryIds: [112324],
    definitionIds: [{ id: 117329, specId: 73 }],
  },
  SPELL_REFLECTION_TALENT: {
    id: 23920,
    name: 'Spell Reflection',
    icon: 'ability_warrior_shieldreflection',
    maxRanks: 1,
    entryIds: [112253],
    definitionIds: [{ id: 117258, specId: 73 }],
  },
  SPITE_TALENT: {
    id: 383852,
    name: 'Spite',
    icon: 'warrior_talent_icon_furyintheblood',
    maxRanks: 2,
    entryIds: [112266],
    definitionIds: [{ id: 117271, specId: 72 }],
  },
  STANCE_MASTERY_TALENT: {
    id: 1280961,
    name: 'Stance Mastery',
    icon: 'crest_warrior',
    maxRanks: 1,
    entryIds: [134031],
    definitionIds: [{ id: 138814, specId: 73 }],
  },
  STEADFAST_AS_THE_PEAKS_TALENT: {
    id: 434970,
    name: 'Steadfast as the Peaks',
    icon: 'ability_warrior_devastate',
    maxRanks: 1,
    entryIds: [118836],
    definitionIds: [{ id: 123736, specId: 73 }],
  },
  STORM_BOLTS_TALENT: {
    id: 436162,
    name: 'Storm Bolts',
    icon: 'warrior_talent_icon_stormbolt',
    maxRanks: 1,
    entryIds: [117414],
    definitionIds: [{ id: 122426, specId: 73 }],
  },
  STORM_BOLT_TALENT: {
    id: 107570,
    name: 'Storm Bolt',
    icon: 'warrior_talent_icon_stormbolt',
    maxRanks: 1,
    entryIds: [112198],
    definitionIds: [{ id: 117203, specId: 73 }],
  },
  STORM_SHIELD_TALENT: {
    id: 438597,
    name: 'Storm Shield',
    icon: 'spell_winston_bubble',
    maxRanks: 1,
    entryIds: [118835],
    definitionIds: [{ id: 123735, specId: 73 }],
  },
  STORM_SURGE_TALENT: {
    id: 275336,
    name: 'Storm Surge',
    icon: 'ability_racial_avatar',
    maxRanks: 1,
    entryIds: [136070],
    definitionIds: [{ id: 140825, specId: 73 }],
  },
  STRATEGIST_TALENT: {
    id: 384041,
    name: 'Strategist',
    icon: 'inv_shield_05',
    maxRanks: 1,
    entryIds: [112157],
    definitionIds: [{ id: 117162, specId: 73 }],
  },
  STRENGTH_OF_ARMS_TALENT: {
    id: 400803,
    name: 'Strength of Arms',
    icon: 'inv_gauntlets_26',
    maxRanks: 2,
    entryIds: [135944],
    definitionIds: [{ id: 140699, specId: 71 }],
  },
  STRENGTH_OF_THE_MOUNTAIN_TALENT: {
    id: 437068,
    name: 'Strength of the Mountain',
    icon: 'ability_warrior_titansgrip',
    maxRanks: 1,
    entryIds: [117405],
    definitionIds: [{ id: 122417, specId: 73 }],
  },
  SUDDEN_DEATH_TALENT: {
    id: 29725,
    name: 'Sudden Death',
    icon: 'ability_warrior_improveddisciplines',
    maxRanks: 1,
    entryIds: [112126, 112301, 132884],
    definitionIds: [
      { id: 117131, specId: 71 },
      { id: 117306, specId: 72 },
      { id: 137670, specId: 73 },
    ],
  },
  SURGE_OF_ADRENALINE_TALENT: {
    id: 1265359,
    name: 'Surge of Adrenaline',
    icon: 'inv_1115_warrior_fasterreflexes',
    maxRanks: 1,
    entryIds: [136449],
    definitionIds: [{ id: 141222, specId: 72 }],
  },
  TACTICAL_EDGE_TALENT: {
    id: 1261051,
    name: 'Tactical Edge',
    icon: 'inv12_ability_warrior_arms',
    maxRanks: 1,
    entryIds: [135939],
    definitionIds: [{ id: 140694, specId: 71 }],
  },
  TACTICIAN_TALENT: {
    id: 184783,
    name: 'Tactician',
    icon: 'ability_warrior_unrelentingassault',
    maxRanks: 1,
    entryIds: [112134],
    definitionIds: [{ id: 117139, specId: 71 }],
  },
  THORIMS_MIGHT_TALENT: {
    id: 436152,
    name: "Thorim's Might",
    icon: 'inv_ability_mountainthanewarrior_thorimsmight',
    maxRanks: 1,
    entryIds: [118834],
    definitionIds: [{ id: 123734, specId: 73 }],
  },
  THUNDERLORD_TALENT: {
    id: 385840,
    name: 'Thunderlord',
    icon: 'ability_vehicle_electrocharge',
    maxRanks: 1,
    entryIds: [112162],
    definitionIds: [{ id: 117167, specId: 73 }],
  },
  THUNDER_BLAST_TALENT: {
    id: 435607,
    name: 'Thunder Blast',
    icon: 'warrior_talent_icon_bloodandthunder',
    maxRanks: 1,
    entryIds: [117382],
    definitionIds: [{ id: 122394, specId: 73 }],
  },
  THUNDER_CLAP_TALENT: {
    id: 6343,
    name: 'Thunder Clap',
    icon: 'spell_nature_thunderclap',
    maxRanks: 1,
    entryIds: [112205],
    definitionIds: [{ id: 117210, specId: 73 }],
    rageCost: 20,
  },
  TIDE_OF_BATTLE_TALENT: {
    id: 429641,
    name: 'Tide of Battle',
    icon: 'ability_warrior_weaponmastery',
    maxRanks: 1,
    entryIds: [117408],
    definitionIds: [{ id: 122420, specId: 73 }],
  },
  TOUGH_AS_NAILS_TALENT: {
    id: 385888,
    name: 'Tough as Nails',
    icon: 'inv_titanium_shield_spike',
    maxRanks: 1,
    entryIds: [112177],
    definitionIds: [{ id: 117182, specId: 73 }],
  },
  TWO_HANDED_WEAPON_SPECIALIZATION_TALENT: {
    id: 382896,
    name: 'Two-Handed Weapon Specialization',
    icon: 'inv_axe_09',
    maxRanks: 2,
    entryIds: [112179],
    definitionIds: [{ id: 117184, specId: 71 }],
  },
  UNHINGED_TALENT: {
    id: 386628,
    name: 'Unhinged',
    icon: 'spell_shadow_spectralsight',
    maxRanks: 1,
    entryIds: [136074],
    definitionIds: [{ id: 140829, specId: 72 }],
  },
  UNRELENTING_ONSLAUGHT_TALENT: {
    id: 444780,
    name: 'Unrelenting Onslaught',
    icon: 'ability_warrior_commandingshout',
    maxRanks: 1,
    entryIds: [117417],
    definitionIds: [{ id: 122429, specId: 72 }],
  },
  UNYIELDING_STANCE_TALENT: {
    id: 1235047,
    name: 'Unyielding Stance',
    icon: 'ability_warrior_defensivestance',
    maxRanks: 1,
    entryIds: [112323],
    definitionIds: [{ id: 117328, specId: 73 }],
  },
  VETERAN_VITALITY_TALENT: {
    id: 440993,
    name: 'Veteran Vitality',
    icon: 'ability_hunter_harass',
    maxRanks: 1,
    entryIds: [119857],
    definitionIds: [{ id: 124757, specId: 73 }],
  },
  VICIOUS_AGILITY_TALENT: {
    id: 444777,
    name: 'Vicious Agility',
    icon: 'ability_paladin_speedoflight',
    maxRanks: 1,
    entryIds: [123408],
    definitionIds: [{ id: 128246, specId: 72 }],
  },
  VICIOUS_CONTEMPT_TALENT: {
    id: 383885,
    name: 'Vicious Contempt',
    icon: 'ability_ironmaidens_sorkasprey',
    maxRanks: 1,
    entryIds: [136448],
    definitionIds: [{ id: 141221, specId: 72 }],
  },
  VIOLENT_EUPHORIA_TALENT: {
    id: 1270717,
    name: 'Violent Euphoria',
    icon: 'ability_butcher_exsanguination',
    maxRanks: 1,
    entryIds: [136076],
    definitionIds: [{ id: 140831, specId: 72 }],
  },
  VIOLENT_OUTBURST_TALENT: {
    id: 386477,
    name: 'Violent Outburst',
    icon: 'ability_warrior_furiousresolve',
    maxRanks: 1,
    entryIds: [112116],
    definitionIds: [{ id: 117121, specId: 73 }],
  },
  WARPAINT_TALENT: {
    id: 208154,
    name: 'Warpaint',
    icon: 'ability_rogue_preparation',
    maxRanks: 1,
    entryIds: [112263],
    definitionIds: [{ id: 117268, specId: 72 }],
  },
  WAR_MACHINE_TALENT: {
    id: 262231,
    name: 'War Machine',
    icon: 'ability_hunter_rapidkilling',
    maxRanks: 1,
    entryIds: [112185],
    definitionIds: [{ id: 117190, specId: 73 }],
  },
  WHIRLING_BLADE_TALENT: {
    id: 1235113,
    name: 'Whirling Blade',
    icon: 'warrior_talent_icon_ravager',
    maxRanks: 1,
    entryIds: [112304],
    definitionIds: [{ id: 117309, specId: 73 }],
  },
  WILD_STRIKES_TALENT: {
    id: 382946,
    name: 'Wild Strikes',
    icon: 'ability_rogue_sprint',
    maxRanks: 2,
    entryIds: [112224],
    definitionIds: [{ id: 117229, specId: 73 }],
  },
  WRATH_AND_FURY_TALENT: {
    id: 392936,
    name: 'Wrath and Fury',
    icon: 'inv_sword_2h_artifactarathor_d_03',
    maxRanks: 1,
    entryIds: [112255],
    definitionIds: [{ id: 117260, specId: 72 }],
  },
  WRECKING_THROW_TALENT: {
    id: 384110,
    name: 'Wrecking Throw',
    icon: 'warrior_talent_icon_mastercleaver',
    maxRanks: 1,
    entryIds: [112215],
    definitionIds: [{ id: 117220, specId: 73 }],
  },
} satisfies Record<string, Talent>;

export default talents;
export { talents as TALENTS_WARRIOR };
